/**
 * Created by Daniela on 26/09/2016.
 */
import { Component }   from '@angular/core';

@Component({
    template: require('./conta-contabil.component.html')
})
export class ContaContabilComponent {}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/contas/conta-contabil/conta-contabil.component.ts
 **/